import type { SlideType } from '#base/core/types/SlideType';

export default [
	{
		title: [
			[
				{
					text: 'Van blessure naar herstel.',
				},
			],
			[
				{
					text: 'Vind je weg terug naar balans.',
				},
			],
			[
				{
					text: 'Hier bereik je meer.',
					isBold: true,
				},
			],
		],
	},
	{
		title: [
			[
				{
					text: 'Hier gaat het om jou.',
				},
			],
			[
				{
					text: 'Met persoonlijke aandacht.',
				},
			],
			[
				{
					text: 'Fysiotherapie, gewoon Hier.',
					isBold: true,
				},
			],
		],
	},
	{
		title: [
			[
				{
					text: 'Persoonlijke aandacht,',
				},
			],
			[
				{
					text: 'daar draait het om.',
				},
			],
			[
				{
					text: 'Je vindt het Hier.',
					isBold: true,
				},
			],
		],
	},
] as SlideType[];
